import { DataProvider } from '@repo/ui/dataProvider'
import { ReactNode, useEffect } from 'react'
import { Location, useOutlet } from 'react-router-dom'

import { AbilityProvider } from '@/routes/AbilityProvider'
import { AuthChecker } from '@/routes/AuthChecker'
import { LoadingRoute } from '@/routes/LoadingRoute'
import { LocationHandler } from '@/routes/LocationHandler'
import { RootState } from '@/store'
import { storeActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'
import { User } from '@/store/user'

export const UserProtectedRoute = () => {
  return (
    <LocationHandler>
      {({ location, routeName }) => (
        <AuthChecker location={location}>
          <RouteInitializer>
            <DataProvider
              loadingComponent={<LoadingRoute />}
              selectors={[(state: RootState) => state.user.me]}
              render={(user) => (
                <AbilityProvider user={user} routeName={routeName}>
                  <OutletHandler location={location} routeName={routeName} user={user} />
                </AbilityProvider>
              )}
            />
          </RouteInitializer>
        </AuthChecker>
      )}
    </LocationHandler>
  )
}

function RouteInitializer({ children }: { children: ReactNode }) {
  const dispatch = useStoreDispatch()
  useEffect(() => {
    void dispatch(storeActions.initApp())
  }, [])
  return children
}

function OutletHandler(props: { location: Location; routeName: string; user: User }) {
  const outletWithContext = useOutlet(props)
  return outletWithContext
}
